import api from "./apiBase";

function getTransactions({
  page = 1,
  limit = 10,
  status,
  startDate,
  endDate,
} = {}) {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);

  if (status && status !== "Todas") params.append("status", status);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);

  return api.get(`/transactions?${params.toString()}`);
}

export {
  getTransactions,
}
